import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const WhatsAppButton = () => {
  const { language } = useLanguage();
  const [showTooltip, setShowTooltip] = useState(false);
  const phoneNumber = '34633368186'; // +34-633368186 without special characters
  
  const messages = {
    en: 'Chat with us on WhatsApp',
    es: 'Chatea con nosotros en WhatsApp',
    de: 'Chatten Sie mit uns auf WhatsApp'
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hola, necesito mas información sobre');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-full right-0 mb-3 whitespace-nowrap">
          <div className="bg-gradient-to-r from-[#1a1d23] to-[#141619] text-white px-4 py-2 rounded-lg border border-[#D4AF37]/30 shadow-xl animate-slide-up">
            <p className="text-sm font-medium">{messages[language]}</p>
            <div className="absolute bottom-0 right-6 transform translate-y-1/2 rotate-45 w-3 h-3 bg-[#1a1d23] border-r border-b border-[#D4AF37]/30"></div>
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className="group relative w-16 h-16 bg-gradient-to-r from-[#25D366] to-[#128C7E] rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 flex items-center justify-center animate-bounce-slow hover:scale-110"
        aria-label="WhatsApp"
      >
        {/* Pulse rings */}
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-75 animate-ping-slow"></span>
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-50 animate-ping-slower"></span>
        
        {/* Icon */}
        <MessageCircle className="w-8 h-8 text-white relative z-10 group-hover:scale-110 transition-transform duration-300" />
        
        {/* Notification dot */}
        <span className="absolute top-0 right-0 w-4 h-4 bg-red-500 rounded-full border-2 border-white animate-pulse"></span>
      </button>
    </div>
  );
};

export default WhatsAppButton;